<script setup lang="ts">
const model = defineModel<boolean>()
const props = defineProps<{
  id: string
  checkedColor?: string
  disabled?: boolean
}>()
</script>

<template>
  <label :for="props.id" class="flex gap-4 ursor-pointer text-sm">
    <input
      :id="props.id"
      :disabled="props.disabled"
      type="checkbox"
      v-model="model"
      class="sr-only"
    />
    <div
      class="relative h-5 w-5 shrink-0 border-gray-400 rounded border bg-white/5"
      :class="[props.checkedColor ? ' border-black' : 'text-white/20']"
    >
      <svg
        v-if="model"
        class="absolute inset-0 h-full w-full"
        :class="[props.checkedColor ? props.checkedColor : 'text-white']"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
      </svg>
    </div>

    <span>
      <slot />
    </span>
  </label>
</template>
